<div class="main-container">
  <div class="header">
    <div>{{ 'my-documents.upload.tutorial.title' | transloco }}</div>
    <c-button type="secondary" size="small" [iconOnly]="true" [icon]="closeIcon" (action)="close(false)" />
  </div>

  @if (activeStep$ | async; as activeStep) {
    <div class="content">
      <c-wizard [activeStep]="activeStep">
        @for (step of tutorialStepsData; track step) {
          <c-wizard-step
            [name]="step.key"
            [activeStep]="activeStep"
            [class.active]="step.key === activeStep">
            <c-tutorial-step [title]="step.title | transloco" [src]="step.src" [description]="step.description | transloco" />
          </c-wizard-step>
        }
      </c-wizard>
    </div>
  }

  <ion-footer class="ion-no-border">
    <ion-toolbar>
      <div class="flex-column gap-8">
        <c-button (action)="next()">
          {{ buttonText$ | async | transloco }}
        </c-button>
        <c-button type="secondary" (action)="close(false)">
          {{ 'my-work.cancel' | transloco }}
        </c-button>
      </div>
    </ion-toolbar>
  </ion-footer>
</div>
